import { PencilIcon, PlusIcon } from '@phosphor-icons/react';
import { useField } from 'formik';
import { useCallback, useMemo } from 'react';
import { useSWRConfig } from 'swr';

import { ISimpleComboboxItem } from '../../../components/combobox/SimpleCombobox';
import { SimpleComboboxField } from '../../../components/combobox/SimpleComboboxField';
import { useProductTypes, PRODUCT_TYPES_SWR_KEY } from '../models';
import { CreateProductTypeDialog } from './CreateProductTypeDialog';
import { UpdateProductTypeDialog } from './UpdateProductTypeDialog';

export interface IMinimalProductType {
  id: string;
  nameNl: string;
}

export const productTypeToComboboxItem = (val: IMinimalProductType): ISimpleComboboxItem => {
  return {
    key: val.id,
    name: `${val.id} - ${val.nameNl}`,
  };
};

export interface IProductTypeComboboxProps {
  name: string;
  labelText?: string;
  isDisabled?: boolean;
  isInvalid?: boolean;
  onBlur?: () => void;
  isNullable?: boolean;
}

export const ProductTypeComboboxField: React.FC<IProductTypeComboboxProps> = (props) => {
  const { labelText, name, ...otherProps } = props;
  const { data } = useProductTypes();
  const { mutate } = useSWRConfig();
  const [field, _meta, helpers] = useField({ name });

  const productTypes = data ?? [];

  const items: ISimpleComboboxItem[] = useMemo(() => {
    return data ? data.map(productTypeToComboboxItem) : [];
  }, [productTypes]);

  const refetch = useCallback(() => {
    mutate(PRODUCT_TYPES_SWR_KEY);
  }, [mutate]);

  const value: ISimpleComboboxItem | null = field.value;
  return (
    <div>
      <div className="flex items-center">
        <SimpleComboboxField labelText={labelText ?? 'Aard'} items={items} name={name} {...otherProps} />

        <div className="flex-end flex justify-end gap-2 ml-2">
          {value && (
            <UpdateProductTypeDialog
              id={value.key}
              onSubmit={(data) => {
                helpers.setValue(productTypeToComboboxItem(data));
                refetch();
              }}
              triggerText={<PencilIcon className="button-icon" />}
            />
          )}

          <CreateProductTypeDialog
            onSubmit={(data) => {
              helpers.setValue(productTypeToComboboxItem(data));
              refetch();
            }}
            triggerText={<PlusIcon className="button-icon" />}
          />
        </div>
      </div>
    </div>
  );
};
